import { IconsTypesProps } from '../icons/types';

export const PropelerPump = ({ width = 64, height = 113 }: IconsTypesProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 113"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_22186_52238)">
      <path
        d="M63.2121 102.095C63.2121 107.916 58.4777 112.612 52.6955 112.612H10.7842C4.9632 112.612 0.267578 107.878 0.267578 102.095C0.267578 96.3131 4.9632 91.5787 10.7842 91.5787H12.0648V77.259H10.7454C7.2916 77.259 4.49751 74.4649 4.49751 71.0111V70.0797C4.49751 66.6259 7.2916 63.8319 10.7454 63.8319H12.0648V18.5444C12.0648 16.41 13.8111 14.6637 15.9455 14.6637H47.4954C49.6298 14.6637 51.3761 16.41 51.3761 18.5444V63.8319H52.6955C56.1493 63.8319 58.9434 66.6259 58.9434 70.0797V71.0111C58.9434 74.4649 56.1493 77.259 52.6955 77.259H51.3761V91.5787H52.6567C58.4777 91.5787 63.2121 96.2743 63.2121 102.095Z"
        fill="#F4F4F7"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M20.6016 22.8131V54.7123"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M26.1514 22.8131V54.7123"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M31.7402 22.8131V54.7123"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M37.3281 22.8131V54.7123"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M42.877 22.8131V54.7123"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M45.1665 14.6248V5.38875C45.1665 2.82751 43.0709 0.770752 40.5485 0.770752H22.7362C20.1749 0.809559 18.1182 2.86631 18.1182 5.38875V14.6248H21.9988V5.38875C21.9988 4.96188 22.3481 4.65143 22.7362 4.65143H40.5097C40.7813 4.65143 41.053 4.80666 41.1694 5.0783V14.6636H45.1665V14.6248Z"
        fill="#C9CDCF"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M31.6218 97.4384C39.8304 97.4384 46.4848 90.784 46.4848 82.5754C46.4848 74.3668 39.8304 67.7124 31.6218 67.7124C23.4132 67.7124 16.7588 74.3668 16.7588 82.5754C16.7588 90.784 23.4132 97.4384 31.6218 97.4384Z"
        fill="#C9CDCF"
      />
      <path
        d="M31.6615 74.1156V60.5332C31.6615 60.5332 26.8883 62.1631 26.7331 68.1393C24.4823 68.9155 22.4255 70.1961 20.7568 71.9036"
        fill="#C9CDCF"
      />
      <path
        d="M31.6615 74.1156V60.5332C31.6615 60.5332 26.8883 62.1631 26.7331 68.1393C24.4823 68.9155 22.4255 70.1961 20.7568 71.9036"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M25.6075 76.6769L16.0222 67.0917C16.0222 67.0917 13.8102 71.5933 17.885 75.9396C16.876 77.9964 16.3715 80.286 16.3715 82.5756C16.3715 82.6532 16.3715 82.692 16.3715 82.7696"
        fill="#C9CDCF"
      />
      <path
        d="M25.6075 76.6769L16.0222 67.0917C16.0222 67.0917 13.8102 71.5933 17.885 75.9396C16.876 77.9964 16.3715 80.286 16.3715 82.5756C16.3715 82.6532 16.3715 82.692 16.3715 82.7696"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M23.1624 82.7695H9.58008C9.58008 82.7695 11.21 87.5816 17.2638 87.7368C18.04 89.9488 19.3594 91.9667 21.0669 93.5966"
        fill="#C9CDCF"
      />
      <path
        d="M23.1624 82.7695H9.58008C9.58008 82.7695 11.21 87.5816 17.2638 87.7368C18.04 89.9488 19.3594 91.9667 21.0669 93.5966"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M25.7239 88.8234L16.1387 98.4086C16.1387 98.4086 20.7567 100.659 25.1418 96.3907C27.1598 97.322 29.3718 97.8265 31.6226 97.8265"
        fill="#C9CDCF"
      />
      <path
        d="M25.7239 88.8234L16.1387 98.4086C16.1387 98.4086 20.7567 100.659 25.1418 96.3907C27.1598 97.322 29.3718 97.8265 31.6226 97.8265"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M31.8164 91.2682V104.851C31.8164 104.851 36.7449 103.182 36.7837 96.934C38.918 96.1579 40.8584 94.916 42.4495 93.325"
        fill="#C9CDCF"
      />
      <path
        d="M31.8164 91.2682V104.851C31.8164 104.851 36.7449 103.182 36.7837 96.934C38.918 96.1579 40.8584 94.916 42.4495 93.325"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M37.8701 88.7068L47.4942 98.3309C47.4942 98.3309 49.7838 93.6352 45.3986 89.2113C46.4076 87.1545 46.9121 84.8649 46.9121 82.5753"
        fill="#C9CDCF"
      />
      <path
        d="M37.8701 88.7068L47.4942 98.3309C47.4942 98.3309 49.7838 93.6352 45.3986 89.2113C46.4076 87.1545 46.9121 84.8649 46.9121 82.5753"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M37.7538 76.5603L47.3779 66.9751C47.3779 66.9751 42.7987 64.7243 38.4523 68.9154C36.3568 67.8676 34.0283 67.3243 31.6611 67.3243"
        fill="#C9CDCF"
      />
      <path
        d="M37.7538 76.5603L47.3779 66.9751C47.3779 66.9751 42.7987 64.7243 38.4523 68.9154C36.3568 67.8676 34.0283 67.3243 31.6611 67.3243"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M31.6228 87.6591C34.4304 87.6591 36.7064 85.383 36.7064 82.5754C36.7064 79.7678 34.4304 77.4917 31.6228 77.4917C28.8151 77.4917 26.5391 79.7678 26.5391 82.5754C26.5391 85.383 28.8151 87.6591 31.6228 87.6591Z"
        fill="#C9CDCF"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
      <path
        d="M42.411 71.7871C44.0797 73.4558 45.3215 75.4349 46.0588 77.6469C52.2291 77.6857 53.8978 82.6142 53.8978 82.6142H40.3154"
        fill="#C9CDCF"
      />
      <path
        d="M42.411 71.7871C44.0797 73.4558 45.3215 75.4349 46.0588 77.6469C52.2291 77.6857 53.8978 82.6142 53.8978 82.6142H40.3154"
        stroke="#231F20"
        strokeWidth="0.776135"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_22186_52238">
        <rect width="64" height="113" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
